export enum LocalStorageEvents {
    CHALLENGE_RECOMMENDATION_DONT_SHOW = 'CHALLENGE_RECOMMENDATION_DONT_SHOW',
    COMPANY_CHALLENGE_DAILY_GOALS_COMPLETED_AND_SEEN = 'companyChallengeDailyGoalsCompletedAndSeen',
    COMPANY_CHALLENGE_DAILY_GOAL_COMPLETED_AND_SEEN = 'companyChallengeDailyGoalCompletedAndSeen',
    COMPANY_CHALLENGE_COMPLETED_AND_SEEN = 'companyChallengeCompletedAndSeen',
    COMPANY_CHALLENGE_THRESHOLD_COMPLETED_AND_SEEN = 'companyChallengeThresholdCompletedAndSeen'
}
